//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useUtils } from '@core/libs/i18n'
import themeConfig from '@themeConfig'

export default {
  setup() {
    const { t } = useUtils()

    return {
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,

      t,
    }
  },
}
